import React from "react";
import PropTypes from "prop-types";
import { MenuButton } from "../styles";

UnorderedListButton.propTypes = {
  editor: PropTypes.object,
  disabled: PropTypes.bool,
};

export default function UnorderedListButton({ editor, disabled = false }) {
  return (
    <MenuButton
      onClick={() => editor.chain().focus().toggleBulletList().run()}
      className={editor.isActive("bulletList") ? "is-active" : ""}
      disabled={disabled}
    >
      <span className="fas fa-list-ul" />
    </MenuButton>
  );
}
